const tokenErrors = ['Forbidden', 'INVALID_TOKEN_REFRESH'];

export const isTokenError = (response) =>
    response ? tokenErrors.includes(response.errorCode) : false;
